import React, { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import Images from "assets/Images";
import {
  Building2, TicketCheck, BarChart3, Settings,
  LogOut, CreditCard
} from "lucide-react";

const S = {
  root:    { display:"flex", fontFamily:"'Outfit',sans-serif", background:"#06101F", minHeight:"100vh", color:"#E8F0FE" },
  sidebar: { width:230, background:"#060F1C", borderRight:"1px solid rgba(0,200,255,0.08)", display:"flex", flexDirection:"column", position:"fixed", top:0, left:0, height:"100vh", zIndex:100 },
  logo:    { padding:"20px 20px 16px", borderBottom:"1px solid rgba(0,200,255,0.08)" },
  logoTop: { display:"flex", alignItems:"center", gap:10 },
  logoIcon:{ width:150, height:50, borderRadius:10, overflow:"hidden", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 },
  logoText:{ fontSize:15, fontWeight:800, color:"#E8F0FE", lineHeight:1.2 },
  logoSub: { fontSize:10.5, color:"#00C8FF", fontWeight:700, letterSpacing:"0.1em", textTransform:"uppercase", marginTop:1 },
  badge:   { display:"inline-block", fontSize:9, fontWeight:700, padding:"2px 7px", borderRadius:10, background:"rgba(0,200,255,0.1)", color:"#00C8FF", letterSpacing:"0.08em", textTransform:"uppercase", marginTop:8, border:"1px solid rgba(0,200,255,0.15)" },
  nav:     { flex:1, overflowY:"auto", padding:"14px 12px" },
  section: { fontSize:9.5, fontWeight:700, color:"#3D5473", letterSpacing:"0.14em", textTransform:"uppercase", padding:"14px 8px 6px" },
  link:    { display:"flex", alignItems:"center", gap:9, padding:"9px 10px", borderRadius:8, textDecoration:"none", color:"#7A93B4", fontSize:12.5, fontWeight:500, marginBottom:2, transition:"all 0.15s" },
  footer:  { padding:"16px 18px", borderTop:"1px solid rgba(0,200,255,0.08)" },
  main:    { marginLeft:230, flex:1, display:"flex", flexDirection:"column" },
  header:  { height:58, background:"#060F1C", borderBottom:"1px solid rgba(0,200,255,0.08)", display:"flex", alignItems:"center", padding:"0 28px", justifyContent:"space-between", position:"sticky", top:0, zIndex:50 },
  content: { padding:"28px 32px 60px", flex:1 },
  avatar:  { width:32, height:32, borderRadius:8, background:"linear-gradient(135deg,#00C8FF,#7C5CFF)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:700, color:"#fff" },
};

const activeStyle = {
  background:"rgba(0,200,255,0.1)",
  color:"#00C8FF",
  borderLeft:"2px solid #00C8FF",
};

const NAV = [
  { section:"OVERVIEW", items:[
    { to:"/super-admin/companies", label:"Companies",   icon:Building2   },
    { to:"/super-admin/dashboard", label:"Analytics",   icon:BarChart3   },
  ]},
  { section:"SUPPORT",  items:[
    { to:"/super-admin/tickets",   label:"All Tickets", icon:TicketCheck },
  ]},
  { section:"PLATFORM", items:[
    { to:"/super-admin/billing",   label:"Billing",     icon:CreditCard  },
    { to:"/super-admin/settings",  label:"Settings",    icon:Settings    },
  ]},
];

const LogoImg = () => (
  <>
    <img
      src={Images?.LOGO || Images?.hirality || Images?.brandLogo}
      alt="Logo" height="150"
      onError={e => { e.currentTarget.style.display="none"; e.currentTarget.nextSibling.style.display="flex"; }}
    />
  </>
);

export default function SuperAdminLayout() {
  const navigate = useNavigate();

  const logout = () => {
    sessionStorage.removeItem("platform_token");
    sessionStorage.removeItem("platform_user");
    navigate("/login");
  };

  return (
    <div style={S.root}>
      {/* Sidebar */}
      <aside style={S.sidebar}>
        <div style={S.logo}>
          <div style={S.logoTop}>
            <div style={S.logoIcon}><LogoImg /></div>
            {/* <div>
              <div style={S.logoText}>Hirality</div>
              <div style={S.logoSub}>Super Admin</div>
            </div> */}
          </div>
       </div>

        <nav style={S.nav}>
          {NAV.map(({ section, items }) => (
            <div key={section}>
              <div style={S.section}>{section}</div>
              {items.map(({ to, label, icon:Icon }) => (
                <NavLink key={to} to={to}
                  style={({ isActive }) => ({ ...S.link, ...(isActive ? activeStyle : {}) })}>
                  <Icon size={15}/>{label}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>

        <div style={S.footer}>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:12 }}>
            <div style={S.avatar}>SA</div>
            <div>
              <div style={{ fontSize:12.5, fontWeight:600, color:"#E8F0FE" }}>Super Admin</div>
              <div style={{ fontSize:11, color:"#7A93B4" }}>superadmin@platform.com</div>
            </div>
          </div>
          <button onClick={logout} style={{ display:"flex", alignItems:"center", gap:7, background:"none", border:"1px solid rgba(0,200,255,0.2)", borderRadius:7, color:"#00C8FF", fontSize:12, padding:"6px 12px", cursor:"pointer", width:"100%", fontFamily:"'Outfit',sans-serif", justifyContent:"center" }}>
            <LogOut size={13}/> Sign Out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main style={S.main}>
        <div style={S.header}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            {/* <div style={{ ...S.logoIcon, borderRadius:7 }}><LogoImg /></div> */}
          </div>
          <div style={{ display:"flex", gap:10, alignItems:"center" }}>
            <div style={{ fontSize:11, padding:"4px 10px", borderRadius:20, background:"rgba(0,229,163,0.12)", color:"#00E5A3", fontWeight:600 }}>● System Online</div>
            <div style={S.avatar}>SA</div>
          </div>
        </div>
        <div style={S.content}><Outlet /></div>
      </main>
    </div>
  );
}